module.exports = __webpack_public_path__ + "img/UserFamilies.617cf336.svg";